import { removeSessionCache } from 'session/src/utils/cacheStorage/removeSessionCache'
import type { SWRConfiguration } from 'swr'
import type { MasterData } from 'types/masterData'

type ErrorRetryHandlerProps = (
	error: Error,
	key: string,
	config: SWRConfiguration,
	revalidate: (opts: { retryCount: number }) => void,
	revalidateOpts: { retryCount: number },
	masterData: MasterData
) => Promise<void>

export const errorRetryHandler: ErrorRetryHandlerProps = async (
	_error,
	_key,
	_config,
	revalidate,
	{ retryCount },
	masterData
) => {
	if (retryCount === 1) {
		revalidate({ retryCount })
	} else {
		console.error('[Auth Orchestrator Service]: Error retrieving session data')
		await removeSessionCache(masterData)
	}
}
